/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { theme as motiliTheme } from '@motili/ui';

const CustomParagraphStyles: {
    [index: string]: { [index: string]: string | number };
} = {
    md: {
        'font-size': '16px',
        'font-weight': 400,
        'line-height': '21px',
        margin: 'revert',
    },
};

const CustomLabelWithRequiredStyles = {
    fontWeight: 700,
    textTransform: 'uppercase',
};

/**
 * Custom component style overrides.
 * Add component-specific style overrides here.
 */
export const customComponentStyles = {
    paragraph: {
        style: (style: string, size: string) => {
            if (CustomParagraphStyles[size]) {
                return CustomParagraphStyles[size][style];
            }
            return CustomParagraphStyles['md'][style];
        },
    },
    labelWithRequired: {
        style: CustomLabelWithRequiredStyles,
    },
};

export const components = {
    ...motiliTheme.components,
    ...customComponentStyles,
};

export type Components = typeof components;
